module.exports = "<div class=\"center-wrap\">\n  <div class=\"center empty-state\">\n    Nothing to see here, folks.\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/quibbl-inspector/quibbl-related/quibbl-related.component.html
// module id = ../../../../../src/app/category/quibbl-inspector/quibbl-related/quibbl-related.component.html
// module chunks = main